import { useEffect, useRef } from 'react';

function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback);

  // Remember the latest callback if it changes.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    // Не планируйте, если delay не указана.
    // Внимание: 0 валидное значение для delay.
    // если в delay добавить тернарник с проверкой на что-нибудь, то хук можно остановить по условию
    // useInterval(() => console.log('bla-bla-bla'), условие ? 3000 : null)
    if (!delay && delay !== 0) {
      return;
    }

    const id = setInterval(() => savedCallback.current(), delay);

    return () => clearInterval(id);
  }, [delay]);
}

export default useInterval;
